import { Component, OnInit, Input } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-jqmeter-bar',
  templateUrl: './jqmeter-bar.component.html',
  styleUrls: ['./jqmeter-bar.component.scss']
})
export class JqmeterBarComponent implements OnInit {
random: string = '_' + Math.random().toString(36).substr(2, 9);
    @Input() goal!: string;
 @Input() raised!: string;
 @Input() width!: string;
 @Input() height!: string;
 @Input() barColor!: string;

constructor() { }

  ngOnInit() {
  }
 ngAfterViewInit(){
 $('#'+this.random).jQMeter({goal: this.goal, raised: this.raised, width: this.width, height: this.height, barColor: this.barColor, animationSpeed: 1000, displayTotal: false});
}

}
